import { useParams } from "react-router-dom";
import { useBooks } from "@/hooks/use-sheets-data";
import { useAnalytics } from "@/hooks/use-analytics";
import { BookCard } from "@/components/books/book-card";

export function Category() {
  const { slug } = useParams<{ slug: string }>();
  const { data: books = [], isLoading } = useBooks();
  useAnalytics();

  // Filter books by category
  const categoryBooks = books.filter(book => {
    if (!book.category || !slug) return false;
    
    // Handle case where category might be an array
    const categories = Array.isArray(book.category) 
      ? book.category
      : typeof book.category === 'string'
        ? book.category.split(';').map(c => c.trim())
        : [];
        
    return categories.map(c => c.toLowerCase()).includes(slug.toLowerCase());
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-xl text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (categoryBooks.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-xl text-muted-foreground">No books found in category: {slug}</p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold mb-2">Category: {slug}</h1>
        <p className="text-muted-foreground">
          Browse books in the {slug} category
        </p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {categoryBooks.map((book) => (
          <BookCard key={book.id} book={book} />
        ))}
      </div>
    </div>
  );
}